/**
 * Display duration ago in human readable format using moment
 */

import * as moment from 'moment';
import { durationObject } from '../../../utility/utils';

export default (Vue) => {
	Vue.filter('inv-ago', (value, suffix, always_ago, weeks_out, format) => {
		return dateAgo(value, suffix, always_ago, weeks_out, format);
	});

	Vue.prototype.$invAgo = (value, suffix, always_ago, weeks_out, format) => {
		return dateAgo(value, suffix, always_ago, weeks_out, format);
	};

	/**
	 * Display duration ago as a human readable format.
	 *
	 * @param value
	 * @param {bool} suffix
	 * @param {bool} always_ago
	 * @param {int} weeks_out
	 * @param {string} format
	 */
	function dateAgo(value, suffix = true, always_ago = false, weeks_out = 2, format = 'MM/DD/YYYY') {
		if (! value) {
			return '';
		}

		let currentDate = moment(value);

		if (currentDate.isValid()) {
			let duration = durationObject(currentDate);

			if (! always_ago && duration.asWeeks() > weeks_out) {
				return currentDate.format(format);
			} else {
				let diff = moment().diff(currentDate);

				if (diff > 0) {
					diff = - diff;
				}

				return moment.duration(diff).humanize(suffix);
			}
		}

		return moment.duration.invalid().humanize();
	}
};